import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import {Vehicle} from 'domain-models'
import {date, hasFlag, monthYear, number, vehicleAttribute} from 'filters'
import React from 'react'
import Trans from '../../../../../components/Trans'

type AttributesProps = {
  vehicle: Vehicle
  preAuction?: boolean
}

class Attributes extends React.Component<AttributesProps> {
  render() {
    const vehicle = this.props.vehicle
    return (
      <div className='px-2 mt-2 flex flex-row flex-wrap'>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='tachometer-alt' /> {number(vehicle.Kilometers, 0, 'km')}
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='calendar-alt' /> {monthYear(vehicle.RegistrationDate)}
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <span className='text-gray-600 font-normal fa-fw font-semibold'><Trans>HU</Trans></span>
          {date(vehicle.InspectionDate)}</span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='burn' /> {number(vehicle.Power, 0, 'kw')}</span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='square' /> {number(vehicle.Displacement, 0, 'ccm')}
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='bolt' /> <Trans>{vehicleAttribute('Transmission', vehicle.Transmission)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='gas-pump' /> <Trans>{vehicleAttribute('Fuel', vehicle.Fuel)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='car-side' /> <Trans>{vehicleAttribute('Engine', vehicle.Engine)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='car-battery' /> <Trans>{vehicleAttribute('Drive', vehicle.Drive)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon={['fas', 'circle']} /> <Trans>{vehicleAttribute('Interior', vehicle.Interior)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='feather' /> <Trans>{vehicleAttribute('SeatCover', vehicle.SeatCover)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon={['far', 'circle']} /> <Trans>{vehicleAttribute('Color', vehicle.Color)}</Trans>
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='door-closed' /> {number(vehicle.NumDoors, 0)}</span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='chair' /> {number(vehicle.NumSeats, 0)}</span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='users' /> {number(vehicle.NumOwners, 0)}</span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='tint' /> {number(vehicle.ConsumCombined, 1, 'l/100km')}
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='star' /> {vehicleAttribute('EfficiencyClass', vehicle.EfficiencyClass)}
        </span>
        <span className='w-1/2 lg:w-1/3 truncate'>
          <Icon className='text-gray-600 font-normal fa-fw' icon='car' /> <Trans>{vehicleAttribute('Type', vehicle.Type)}</Trans>
        </span>
        {vehicle.envkv?.EmissionsCombined
          ? <span className='w-1/2 lg:w-1/3 truncate'>
              <Icon className='text-gray-600 font-normal fa-fw' icon='leaf' /> {number(vehicle.envkv.EmissionsCombined, 0, 'g/km')} CO₂ WLTP
            </span>
          : null
        }
        {vehicle.envkv?.EmissionsCombinedWeighted
          ? <span className='w-1/2 lg:w-1/3 truncate'>
              <Icon className='text-gray-600 font-normal fa-fw' icon='leaf' /> {number(vehicle.envkv.EmissionsCombinedWeighted, 0, 'g/km')} CO₂ WLTP <Trans>gew.</Trans>
            </span>
          : null
        }
        {vehicle.Weight
          ? <span className='w-1/2 lg:w-1/3 truncate'>
              <Icon className='text-gray-600 font-normal fa-fw' icon='weight' /> {number(vehicle.Weight, 0, 'kg')}
            </span>
          : null
        }

        <span className='w-full'>{hasFlag(vehicle, 'SellFlags', 32768) ?
          <span><Icon className='text-gray-600 font-normal fa-fw' icon='search-dollar' /> <Trans>MwST. ausweisbar</Trans></span>
          :
          <span><Icon className='text-gray-600 font-normal fa-fw' icon='search-dollar' /> <Trans>MwST. nicht ausweisbar</Trans></span>
        }</span>

        {
          this.props.preAuction ?
            <span className='w-full'>
              <span>
                <span className={'text-gray-600 font-normal'}><Trans>Lieferdatum</Trans>:</span>
                {date(vehicle.DeliveryDate)}</span>
            </span>
            : null
        }
      </div>
    )
  }
}

export default Attributes
